<div id="{{ question.key }}" [ngClass]="{ 'st-danger': question.theme === 1 }">
  <label
    for="{{ question.key }}"
    [ngClass]="{ required: question.required && !question.readOnly }"
    [textContent]="question.displayText"
  ></label>
  <div
    kendoTooltip
    *ngIf="tooltipText!"
    title="{{ tooltipText! }}"
    style="display: inline"
  >
    &nbsp; 🛈
  </div>
  <div *ngIf="!question.readOnly">
    <kendo-numerictextbox
      id="{{ question.key }}_numericBox"
      name="{{ question.key }}"
      class="form-control"
      type="text"
      [min]="0"
      [maxlength]="question.maxLength!"
      [(ngModel)]="QuestionAnswerFormatted"
      [disabled]="question.isDisabled!"
      [spinners]="false"
      [format]="'#'"
      [decimals]="0"
    >
    </kendo-numerictextbox>
  </div>
  <div *ngIf="question.readOnly">
    <p *ngIf="question.isAnswered()">{{ question.answer }}</p>
    <span class="unattended" *ngIf="!question.isAnswered()">{{
      noAnswerDefaultText
    }}</span>
  </div>
</div>
